export interface VetMemberAccountModel {
  checkbox: boolean;
  memberId: any,
  userId: any,
  memberName: string,
  saleName: string,
  saleAccess: string,
  accessStatusCode: string,
  phoneNumber: string,
  vetName: string,
  emailAddress: string,
  address: string,
  city: string,
  stateName: string,
  postCode: string,
  countryName: string,
  organisationID: any,
  websiteUrl: string,
  mobile: string,
  phoneNumber1: string,
  phoneNumber2: string,
  contactNumber1: string,
  contactNumber2: string
  accreditationNumber: string
}

export enum VetMemberAccountTableFields {
  VET_NAME = 'vetName',
  EMAIL_ADDRESS = 'emailAddress',
  MOBILE = 'mobile',
  CLINIC = 'memberName',
  ORGANISATION_ID = 'organisationID',
  ACCREDITATION_NUMBER = 'accreditationNumber',
  SALE = 'sale',
  SALEACCESS = 'saleAccess'
}
